import React from "react";
import ResultHistory from "./ResultHistory";
import TabView from "../lotto/TabView";
import {useLotto12v2} from "../../store/lotto12v2/Lotto12v2Context";


const RightSide = () => {
    const lotto = useLotto12v2();
    const {t} = lotto;

    const tabs = [t("labels:drawing.drawPrefix.new_result")];
    const children = [
        <ResultHistory/>
    ]

    return <div className="r-side">
        <TabView children={children} tabs={tabs}/>
    </div>
}

export default RightSide;

